import { render } from "./RengongYlqRwKFView.vue?vue&type=template&id=72de4a0c"
import script from "./RengongYlqRwKFView.vue?vue&type=script&lang=js"
export * from "./RengongYlqRwKFView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\allNewWeb\\ant-vue\\daifanew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__